import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Navbar from "../../../atoms/navbar";

import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Modal,
    Table,
    Upload,
} from "antd";
import { Block, Confirm, Loading, Report } from "notiflix";
import { UploadOutlined } from '@ant-design/icons';
import { use } from "react";
import { QuestionOutlined, DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";
import { loginRequest } from "../../../config/api.config";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export default function SapCreateBidding() {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [vendorNotes, setVendorNotes] = useState({});
    const [hasInitialized, setHasInitialized] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [NewVendorName, setNewVendorName] = useState('');
    const [NewQuotationNumber, setNewQuotationNumber] = useState('');
    const [vendorSelected, setVendorSelected] = useState([]);
    const [biddingHdr, setBiddingHdr] = useState([]);
    const [approval, setApproval] = useState([]);
    const [userBranch, setUserBranch] = useState([]);
    const { instance, accounts } = useMsal();
    const [fileList, setFileList] = useState({});
    const [vendorErp, setVendorErp] = useState([]);
    const [idRecord, setIdRecord] = useState('');
    const [formVendor] = Form.useForm();
    const [currentSession, setCurrentSession] = useState(
        JSON.parse(localStorage.getItem("session_signin"))
    );
    const isAuthenticated = useIsAuthenticated();

    const navigate = useNavigate();

    const { id } = useParams();

    const inisialVendors = []
    const InitialBiddingHdr = {
        description: "",
        req_num: "",
        selectedVendor: "",
        vendorValue: "",
        buyer_id: "",
        buyer_name: "",
        additional_information: "",
    }

    const rowSelection = {
        type: "radio",
        selectedRowKeys: selectedRowKey !== null ? [selectedRowKey] : [],
        onChange: (keys) => {
            setSelectedRowKey(keys[0]);
            const updatedVendors = vendors.map((vendor, index) => ({
                ...vendor,
                selected: keys[0] === index,
            }));
            setVendors(updatedVendors);
        },
    };

    const columns = [
        {
            title: "Vendor Name",
            dataIndex: "vendor_name",
        },
        {
            title: "Quotation Number",
            dataIndex: "quotation_number",
        },
        {
            title: "Price",
            dataIndex: "quotation_price",
        },
        {
            title: "Keterangan",
            render: (_, record, index) => {
                const checked = selectedRowKey === index;

                return (
                    <Input
                        placeholder="Keterangan vendor"
                        value={vendorNotes[index]}
                        onChange={(e) => {
                            const updateVendor = vendors.map((vendor, index) => ({
                                ...vendor,
                                vendorNotes: index === selectedRowKey ? e.target.value : vendor.vendorNotes
                            }))
                            setVendors(updateVendor);
                        }}
                    />
                );
            },
        },
        {
            title: "Action",
            render: (_, record, index) => {
                return (
                    <Button
                        danger
                        onClick={() => handleDeleteVendor(index)}
                    >
                        Delete
                    </Button>
                );
            },
        },
    ];

    const handleDeleteVendor = (indexToDelete) => {
        const filtered = vendors.filter((_, index) => index !== indexToDelete);
        setVendors(filtered);
    };

    const getVendor = async () => {
        try {
            const headers = await getTokenHeaders();

            const { data } = await API.VendorCapex(headers);
            setVendorErp(data);
        } catch (error) {
            console.error(error);
        } finally {
            Loading.remove();
        }
    };

    const getUsersBranch = async () => {
        try {
            const headers = await getTokenHeaders();
            const response = await API.UserBranchID(headers, '0, 48274');
            if (response.code == 200) {
                setUserBranch(response.data);
            }
        } catch (error) {
            console.error("Error in getEmployeeTalentaByBranch:", error);
            return [];
        }
    }



    useEffect(() => {
        getUsersBranch();
    }, [id])

    function RequestToken() {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                if (!currentSession) {
                    getUser(response.accessToken);
                }

            })
            .catch((e) => {
                handleLogin(instance);
                console.error(e);
            });
    }

    function handleLogin(instance) {
        instance
            .loginRedirect(loginRequest)
            .then(() => { })
            .catch((e) => {
                console.error(e);
            });
    }

    const onFinish = async (values) => {
        try {
            Loading.dots("Processing your request...");
            const dataToSubmit = {
                ...values,
                vendors: vendors,
                buyer_id: currentSession.nik,
                buyer_name: currentSession.fullname,
            };

            console.log('Form values: ', dataToSubmit);

            const headers = await getTokenHeaders();
            await API.sapCreateBidding(headers, dataToSubmit);
            Report.success(
                "Your response has been recorded.",
                "Thank you",
                    "Okay",
                    function () {
                        Loading.remove();
                        navigate("/sapbdng/history");
                    }
                );
            Loading.remove();
        } catch (error) {
            Loading.remove();
            console.error(error);
            Report.failure(
                "Failed to submit your bidding.",
                "Please try again later.",
                "Okay",
                function () {
                    Loading.remove();
                }
            );
        }

    }

    const getTokenHeaders = async () => {
        const tokenRequest = {
            ...loginRequest,
            account: accounts[0],
        };

        const responseToken = await instance.acquireTokenSilent(tokenRequest);
        const accessToken = responseToken.accessToken;

        return HeaderFarms(accessToken);
    };

    async function getUser(token) {
        try {
            const user = await API.getUserCredential(HeaderFarms(token), {
                access_token: token,
            });
            setCurrentSession(user);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {

        if (!isAuthenticated) {
            RequestToken();
        } else {
            if (instance.getAllAccounts().length > 0) {
                instance.setActiveAccount(accounts[0]);
                RequestToken();

            } else {
                handleLogin(instance);
            }
        }
    })

    const { Panel } = Collapse;
    const { TextArea } = Input
    const { Option } = Select;
    return (
        <>
            <Navbar
                title="Create"
                back={true}
                subtitle="Bidding"
                navigate="/sapbdng/history"
            />
            <div className="container-fluid white-back-cr">
                <Form
                    form={form}
                    scrollToFirstError={true}
                    name="service_request_form"
                    encType="multipart/form-data"
                    autoComplete="off"
                    size="middle"
                    layout="vertical"
                    onFinish={onFinish}

                >
                    <div className="container p-3" style={{ alignSelf: "center" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <Collapse
                                    className="collapse_sr"
                                    expandIconPosition={"end"}
                                    bordered={true}
                                    defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                >
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Summary</b>}
                                        key="1"
                                    >
                                        <Row gutter={10} className="mb-1">
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Department"
                                                    name="department"
                                                    rules={[
                                                        { required: true, message: "Please input Department" },
                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="RFQ Number"
                                                    name="rfq_number"
                                                    rules={[
                                                        { required: true, message: "Please input RFQ Number" },
                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="RFQ Link"
                                                    name="rfq_link"
                                                    rules={[
                                                        { required: true, message: "Please input RFQ Link" },
                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Vendor</b>}
                                        key="1"
                                    >
                                        <Table
                                            dataSource={vendors}
                                            rowKey={(record, index) => index}
                                            pagination={false}
                                            columns={columns}
                                        />
                                        <Button
                                            type="primary"
                                            htmlType="button"
                                            className="btn btn-primary btn-block mt-3"
                                            style={{ width: "20%" }}
                                            onClick={() => setIsModalOpen(true)}
                                        >
                                            Add Vendor
                                        </Button>
                                        <Modal
                                            title="Add Vendor"
                                            open={isModalOpen}
                                            onCancel={() => setIsModalOpen(false)}
                                            onOk={() => {
                                                formVendor.validateFields().then((values) => {
                                                    const vendorNotes = '';
                                                    const selected = false;
                                                    values.vendorNotes = vendorNotes;
                                                    values.selected = selected;
                                                    setVendors([...vendors, values]);
                                                    formVendor.resetFields();
                                                    setIsModalOpen(false);
                                                });
                                            }}
                                        >
                                            <Form form={formVendor} layout="vertical">
                                                <Form.Item
                                                    label="Vendor Name"
                                                    name="vendor_name"
                                                    rules={[{ required: true, message: "Please input Vendor Name" }]}
                                                >
                                                    <Input />
                                                </Form.Item>

                                                <Form.Item
                                                    label="Quotation Number"
                                                    name="quotation_number"
                                                    rules={[{ required: true, message: "Please input Quotation Number" }]}
                                                >
                                                    <Input />
                                                </Form.Item>

                                                <Form.Item
                                                    label="Price"
                                                    name="quotation_price"
                                                    rules={[{ required: true, message: "Please input Price" }]}
                                                >
                                                    <Input type="number" />
                                                </Form.Item>
                                            </Form>
                                        </Modal>


                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Additional Information</b>}
                                        key="1"
                                    >
                                        <Row gutter={10} className="mb-1">
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Vendor recommendation"
                                                    name="vendor_recommendation"
                                                    rules={[
                                                        { required: true, message: "Please input Vendor recommendation" },
                                                    ]}
                                                >
                                                    <Select
                                                        placeholder="Select Vendor recommendation"
                                                        onChange={(value) => {
                                                            const updatedVendors = vendors.map((vendor, index) => ({
                                                                ...vendor,
                                                                selected: vendor.vendor_name === value
                                                            }));
                                                            setVendors(updatedVendors);
                                                        }}
                                                    >
                                                        {vendors.map((vendor, index) => (
                                                            <Select.Option key={index} value={vendor.vendor_name}>
                                                                {vendor.vendor_name || ''}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Additional Information"
                                                    name="additional_information"
                                                    rules={[
                                                        { required: true, message: "Please input Additional Information" },
                                                    ]}
                                                >
                                                    <Input.TextArea
                                                        rows={4}
                                                        placeholder="Input Additional Information"
                                                    />
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 24 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                {/* <Form.Item
                                                    label="File Attachment"
                                                    name="attachment"
                                                    valuePropName="fileList"
                                                    getValueFromEvent={e => Array.isArray(e) ? e : e && e.fileList}
                                                    rules={[{ message: "Please upload a file" }]}
                                                >
                                                    <Upload beforeUpload={() => false} multiple>
                                                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                    </Upload>
                                                </Form.Item> */}
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Approval</b>}
                                        key="1"
                                    >
                                        <Form.List name="approvals">
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map((field, index) => (
                                                        <Row
                                                            key={field.key}
                                                            gutter={10}
                                                            justify="center"
                                                            className="mb-2"
                                                        >
                                                            <Col xs={24} sm={7} xl={7}>
                                                                <Form.Item
                                                                    {...field}
                                                                    name={[field.name, "approval_user_id"]}
                                                                    rules={[{ required: true }]}
                                                                >
                                                                    <Select
                                                                        placeholder="Select an option"
                                                                        showSearch
                                                                        optionFilterProp="children"

                                                                    >
                                                                        {userBranch.map((user) => (
                                                                            <Option key={user?.employee_id} value={user?.employee_id}>
                                                                                {user?.fullname} / ({user?.employee_id})
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            {/* tombol hapus kalau lebih dari 1 */}
                                                            {index > 0 && (
                                                                <Col className="mt-1">
                                                                    <Button danger onClick={() => remove(field.name)}>
                                                                        Remove
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    ))}

                                                    {/* Tombol Add Approval */}
                                                    <Row justify="center">
                                                        <Col xs={24} className="text-center mt-3">
                                                            <Button
                                                                type="primary"
                                                                onClick={() => add()}
                                                            >
                                                                Add Approval
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </Form.List>
                                    </Panel>
                                </Collapse>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: "30px" }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="btn btn-primary btn-block mt-3"
                                        style={{ width: "50%" }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
}
